<template>
<div class="chapter">
<div class="inner_page">
<p class="SP1"> </p>
<p class="DEDF"><span class="ePub-BI">TO THE MEMORY OF MABEL T. BELCHER.</span></p>
<p class="DED"><span class="ePub-I">The greatest mother, father, friend, and supporter a man could ever ask for. This one is for you, Mom. They are all for, and because of, you.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?45316c0b